<div fxLayout="column" fxLayoutAlign="center center" class="neq-page" *ngIf="intializationDone">
  <ng-container *ngIf="activities">
    <h2>{{ 'label.user.login.entity-choice.choose-activity' | translate }}</h2>
    <div class="screen-width">
      <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="0.714rem">
        <a mat-button *ngFor="let activity of activities" (click)="onActivityClicked(activity)">
          {{ activity.label }}
        </a>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="operatingModes && !selectedOperatingMode">
    <h2>{{ 'label.user.login.entity-choice.choose-operating-mode' | translate }}</h2>
    <div class="screen-width">
      <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="0.714rem">
        <a mat-button *ngFor="let opMode of operatingModes" (click)="onOperatingModeSelection(opMode)">
          {{ returnOperatingModeTranslationKey(opMode) | translate }}
        </a>
      </div>
    </div>
    <div *ngIf="operatingModes.length === 0" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="0.714rem">
      <span>{{ 'label.user.login.entity-choice.no-operating-mode' | translate }}</span>
      <div fxLayout="row" fxLayoutGap="0.714rem">
        <a mat-button (click)="logout()">{{ 'label.common.logout' | translate }}</a>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="selectedOperatingMode && entities">
    <h2>{{ 'label.user.login.entity-choice.choose-entity' | translate }}</h2>
    <div class="screen-width">
      <div fxLayout="row wrap" fxLayoutAlign="center stretch" fxLayoutGap="0.714rem">
        <a mat-button *ngFor="let entity of entities" (click)="onEntityClicked(entity)" fxLayout="column"
           fxLayoutAlign="end center">
          <div fxLayout="column" fxLayoutAlign="end center">
            <img *ngIf="entity.logo" [src]="entity.logo" alt="entity.logo">
            <span>{{ entity.name }}</span>
          </div>
        </a>
      </div>
    </div>
    <div *ngIf="canAccessAdminSite() && entities.length === 0" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="0.714rem">
      <span>{{ 'label.user.login.entity-choice.admin-no-entities' | translate }}</span>
      <div fxLayout="row" fxLayoutGap="0.714rem">
        <a mat-button (click)="goToAdmin()">{{ 'label.user.link.admin' | translate }}</a>
        <a mat-button (click)="logout()">{{ 'label.common.logout' | translate }}</a>
      </div>
    </div>
  </ng-container>

  <div *ngIf="!hasMultipleActivities && !hasEntities" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="0.714rem">
    <span>{{ 'label.user.login.entity-choice.no-entities' | translate }}</span>
    <a mat-button (click)="logout()">{{ 'label.common.logout' | translate }}</a>
  </div>
</div>
